import { apiClient } from '@/core/api/client';
import type { PaginatedResponse } from '../../types/pagination.type';
import type {
  VectorDbSyncName,
  VectorDbSyncCheckResult,
  VectorDbSyncQueuedResult,
  VectorDbJobHistoryItem,
  VectorDbJobHistoryParams,
} from '../types/vector-db.type';

const BASE_PATH = '/admin/vector-db';

export async function checkVectorDbSync(name: VectorDbSyncName): Promise<VectorDbSyncCheckResult> {
  const response = await apiClient.get<VectorDbSyncCheckResult>(`${BASE_PATH}/sync-check`, {
    params: { name },
  });
  return response.data;
}

export async function syncProvidersVectorDb(): Promise<VectorDbSyncQueuedResult> {
  const response = await apiClient.post<VectorDbSyncQueuedResult>(`${BASE_PATH}/sync-providers`);
  return response.data;
}

export async function syncResourcesVectorDb(): Promise<VectorDbSyncQueuedResult> {
  const response = await apiClient.post<VectorDbSyncQueuedResult>(`${BASE_PATH}/sync-resources`);
  return response.data;
}

/**
 * Proxied through our backend — never call Care Engine's background-jobs endpoint
 * directly. One call per page: only `params.page`'s slice comes back, same
 * page/pageSize contract the provider list uses.
 */
export async function getVectorDbJobHistory(
  name: VectorDbSyncName,
  params: VectorDbJobHistoryParams,
): Promise<PaginatedResponse<VectorDbJobHistoryItem>> {
  const response = await apiClient.get<PaginatedResponse<VectorDbJobHistoryItem>>(`${BASE_PATH}/job-history`, {
    params: { name, page: params.page, pageSize: params.pageSize },
  });
  return response.data;
}

export const vectorDbApi = {
  checkVectorDbSync,
  syncProvidersVectorDb,
  syncResourcesVectorDb,
  getVectorDbJobHistory,
};
